import { addToCart, addWishList, removeWishList } from './functions';

export const downAction = async (id, setCartProductsList, cartProductsList, productId, setProductLoading) => {
    const response = await addToCart(id, 1, setProductLoading);
    if (response.success) {
        setCartProductsList([...cartProductsList, { id: productId, quantity: 1 }]);
    }
}

export const upAction = async (wishList, id, setWishList) => {
    const filterWishListId = wishList?.find(list => parseInt(list?.id) === id);
    if (filterWishListId) {
        const response = await removeWishList(id);
        if (response?.success) {
            const updatedWishList = wishList.filter(list => parseInt(list.id) !== id);
            setWishList(updatedWishList);

        }

    }
    else {
        const response = await addWishList(id);
        if (response.success) {
            setWishList([...wishList, { id }]);
        }
    }
}